export default __webpack_public_path__ + "static/media/adaptive-icon.393c08ec.png";